import "./additionalPages.css";
import Header from "../header/HeaderNavbar";
import Footer from "../footer/Footer";
import ScrollUp from "../scroll up/ScrollUpBtn";

export default function ConsentText({ windowWidth }) {
  return (
    <>
      <Header windowWidth={windowWidth}/>
      {windowWidth > 1200 && <ScrollUp />}
      <div className="mainText col">
        <h1>СОГЛАШЕНИЕ ОБ ОБРАБОТКЕ ПЕРСОНАЛЬНЫХ ДАННЫХ</h1>
        <hr />
        <p>
          Предоставляя свои персональные данные, Пользователь даёт согласие на
          обработку, хранение и использование своих персональных данных на
          основании Федерального закона от 27.07.2006 N 152-ФЗ «О персональных
          данных» в следующих целях:
          <br />
          <br />
          — идентификации Пользователя, зарегистрированного на Сайте, для
          заключения договора с Компанией;
          <br />
          — предоставления Пользователю доступа к персонализированным ресурсам
          Сайта;
          <br />
          — установления с Пользователем обратной связи, включая направление
          уведомлений, запросов, касающихся использования Сайта, оказания услуг,
          обработка запросов и заявок от Пользователя;
          <br />
          — определения места нахождения Пользователя для обеспечения
          безопасности, предотвращения мошенничества;
          <br />
          — подтверждения достоверности и полноты персональных данных,
          предоставленных Пользователем;
          <br />
          — создания учетной записи для совершения платежей, если Пользователь
          дал согласие на создание учетной записи;
          <br />
          — обработки и получения платежей, подтверждения налога или налоговых
          льгот, оспаривания платежа, определения права на получение кредитной
          линии Пользователем;
          <br />
          — предоставления Пользователю эффективной клиентской и технической
          поддержки при возникновении проблем связанных с использованием Сайта;
          <br />
          — предоставления Пользователю с его согласия, обновлений услуг,
          специальных предложений, информации о ценах, новостной рассылки и иных
          сведений от имени Компании или от имени партнеров Компании;
          <br />
          — осуществления рекламной деятельности с согласия Пользователя;
          <br />
          — проведения аудита и прочих внутренних исследований с целью повышения
          качества предоставляемых услуг.
          <br />
          Под Персональными данными подразумевается любая информация,
          относящаяся к прямо или косвенно определенному или определяемому
          физическому лицу (субъекту персональных данных – Пользователь) и
          включают в себя следующую информацию:
          <br />
          — фамилию, имя, отчество Пользователя;
          <br />
          — контактный телефон Пользователя;
          <br />
          — адрес электронной почты (e-mail) Пользователя.
          <br />
          Под Персональными данными подразумевается любая информация,
          относящаяся к прямо или косвенно определенному или определяемому
          физическому лицу (субъекту персональных данных – Пользователь) и
          включают в себя следующую информацию: Компания обязуется не передавать
          полученные персональные данные третьим лицам, за исключением следующих
          случаев предусмотренных законодательством Российской Федерации.
          Компания оставляет за собой право вносить изменения в одностороннем
          порядке в настоящие правила, при условии, что изменения не
          противоречат действующему законодательству Российской Федерации.
          Изменения условий настоящих правил вступают в силу после их публикации
          на Сайте.
          <br />
          <br />
          ИП Артемьев Артём Сергеевич ИНН 210802556940
        </p>
      </div>
      <Footer />
    </>
  );
}
